export default {
    data: {
        idItemSelected: null,
        optionsValue: "",
    },
    show: false,
}